import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Data Master Gudang',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Gudang',
        href: '/adm/logistic/gudang',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'code_gudang',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'gudang',
        label: 'Gudang',
        sortable: true,
      },
      {
        key: 'address',
        label: 'Alamat',
      },
      {
        key: 'city',
        label: 'Kota',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      gudang: '',
      address: '',
      city: '',
      postal_code: '',
      country: '',
      remark: '',
      is_active: 1,
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeGudang(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchGudang(context, params = null) {
    let result = await ApiGetRequest(`logistic/gudang`, params);
    return !result.error ? result.data.object : [];
  },

  async getAllGudang({ commit }) {
    commit('changeGudang', {
      loading: true,
    });

    let result = await ApiGetRequest(`logistic/gudang`);
    commit('changeGudang', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListGudang({ commit, state }) {
    commit('changeGudang', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`logistic/gudang`, params);
    commit('changeGudang', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailGudang({ commit, state }, payload = null) {
    commit('changeGudang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/gudang/${payload.id}`);
    commit('changeGudang', {
      loading: false,
      detail: result.error ? false : result.data.object,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async importData({ commit, state, dispatch }) {
    commit('changeGudang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`logistic/gudang/import`, {
      items: data.import_form,
    });

    commit('changeGudang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createGudang({ commit, state, dispatch }) {
    commit('changeGudang', {
      loading: true,
    });

    let result = await ApiPostRequest(`logistic/gudang`, state.data.form);
    commit('changeGudang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateGudang({ commit, state, dispatch }, payload = null) {
    commit('changeGudang', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `logistic/gudang/${payload.id}`,
      state.data.form
    );

    commit('changeGudang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteGudang({ commit, dispatch }, payload = null) {
    commit('changeGudang', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`logistic/gudang/${payload.id}`);
    commit('changeGudang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
